/* eslint-disable vue/no-side-effects-in-computed-properties */
<template>
  <v-container fluid>
    <v-row class="d-print-none" align="center" justify="center">
      <v-col cols="12" sm="8" md="8">
        <v-card class="elevation-12" :loading="state == 'READING'">
          <v-toolbar color="primary" dark flat>
            <v-toolbar-title>Kies bestand</v-toolbar-title>
            <div class="flex-grow-1"></div>
          </v-toolbar>
          <v-card-text>
            <v-form>
              <v-file-input
                show-size
                counter
                multiple
                :loading="state == 'READING'"
                label="Te ontdubbelen bestand"
                @change="readFile"
              ></v-file-input>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row align="center" justify="center">
      <v-col v-if="parsedContents.length" cols="12">
        <v-tabs
          v-model="activeTab"
          :grow="true"
          :centered="false"
          :dark="true"
          :align-with-title="true"
        >
          <v-tab key="dubbel">Patiënten met dubbele declaraties</v-tab>
          <!-- <v-tab key="all">Alle patiënten in file</v-tab> -->
          <v-tab key="stats"
            >Statistieken, {{ tot_decl }} declaraties,
            {{ tot_revn | currency }}</v-tab
          >
          <v-tab-item key="dubbel">
            <v-row>
              <v-col cols="12">
                <v-alert text type="info" icon="mdi-arrow-right"
                  >{{ patienten_met_dubbel.length }} patiënten met mogelijk
                  dubbele declaraties gevonden.</v-alert
                >
              </v-col>
              <Patient
                v-for="(p, index) in patienten_met_dubbel"
                :key="index"
                :patient="p"
              ></Patient>
            </v-row>
          </v-tab-item>
          <v-tab-item key="stats">
            <v-row>
              <v-col cols="12">
                <v-simple-table :dense="true" :fixed-header="true">
                  <thead>
                    <th class="text-left">Code</th>
                    <th class="text-right">Aantal</th>
                    <th class="text-right">Omzet</th>
                  </thead>
                  <tbody>
                    <tr v-for="code in sorted_alle_codes" :key="code.code">
                      <td>{{ code.code }}</td>
                      <td class="text-right">{{ code.aantal }}</td>
                      <td class="text-right">{{ code.omzet | currency }}</td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr class="font-weight-bold">
                      <td>Totaal</td>
                      <td class="text-right">{{ tot_decl }}</td>
                      <td class="text-right">{{ tot_revn | currency }}</td>
                    </tr>
                  </tfoot>
                </v-simple-table>
              </v-col>
            </v-row>
          </v-tab-item>
          <!-- <v-tab-item key="all">
            <v-row>
              <Patient
                v-for="(p, index) in patienten"
                :patient="p"
                :key="index + '_'"
              ></Patient>
            </v-row>
          </v-tab-item> -->
        </v-tabs>
      </v-col>
      <v-col v-else-if="state == 'DONE'">
        <v-alert text type="error" icon="mdi-alert"
          >Fout tijdens laden bestand {{ selected_file.name }}</v-alert
        >
      </v-col>
      <v-col v-else cols="12" md="8">
        <p>
          Dit programmaatje is bedoeld om in
          <strong>medicom</strong> proforma declaratiebestanden van
          verrichtingen te controleren op eventuele onjuist geboekte contacten.
        </p>
        <ol>
          <li>
            <strong>INSTELLINGEN:</strong> het systeem moet eenmalig zo
            ingesteld worden dat proforma declaraties niet automatisch geprint
            worden, maar in een bestand terecht komen.
            <ul>
              <li>hoofdmenu</li>
              <li>praktijkbeheer</li>
              <li>onderhoud parameters overzichten</li>
              <li>blader door naar DCL004 proforma/copie declaraties</li>
              <li>
                potloodje: wijzig bewaartermijn in bv 30 dagen en 'uitvoer':'in
                een bestand opslaan'. Geen logo.
              </li>
            </ul>
          </li>
          <li>
            <strong>CONTROLE</strong>
            <ul>
              <li>proforma declaraties aanmaken</li>
              <li>
                downloaden van het bestand: boompje, praktijkbeheer,
                printmanager, kies het DCL004 bestand
                <br />Klik op het menu-icoontje en kies 'download' <br />Het
                bestand komt standaard in c:\ppcomm te staan. de naam begint
                altijd met DCL004
              </li>
            </ul>
          </li>
        </ol>
        <p style="padding-top: 10px;">
          klik nu hierboven op bladeren en kies het DCL004 bstand. Het resultaat
          verschijnt op je scherm en kan evt ook geprint worden.
          <em
            >NB: de output moet handmatig gecontroleerd worden in je systeem.
            Dit programma verandert niets aan je bestanden!</em
          >
        </p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Patient from "@/components/Patient.vue";
// import test_contents from "@/assets/test_file.js";

export default {
  name: "Home",
  components: {
    Patient
  },
  data() {
    let alle_consulten = ["C", "DC", "V", "DV", "KC"];
    return {
      activeTab: 0,
      alle_codes: {},
      file_contents: null,
      state: "IDLE",
      selected_file: null,
      codes_allow_dubbel: ["R"],
      codes_need_others: {
        UCONTR: alle_consulten,
        STIKSTOF: alle_consulten,
        ZWREACT: alle_consulten,
        HECHT: alle_consulten,
        TAPEVB: alle_consulten,
        CRP: ["DC", "DV"]
      },
      codes_warn_others: {
        ECG: alle_consulten,
        INJ: alle_consulten,
        SPI: alle_consulten,
        MMSE: alle_consulten
      },
      codes_opt_others: ["GLU"]
    };
  },
  computed: {
    tot_decl() {
      let a = 0;
      for (const [code, data] of Object.entries(this.alle_codes)) {
        a += data["aantal"];
      }
      return a;
    },
    tot_revn() {
      let a = 0;
      for (const [code, data] of Object.entries(this.alle_codes)) {
        a += data["omzet"];
      }
      return a;
    },
    sorted_alle_codes() {
      let a = [];
      for (const [code, data] of Object.entries(this.alle_codes)) {
        a.push(data);
      }
      let x = a.sort(function(a, b) {
        return b["aantal"] - a["aantal"];
      });
      return x;
    },
    patienten_met_dubbel() {
      return this.patienten.filter(patient => {
        return patient.dubbel_msg.length > 0 || patient.warn_msg.length > 0;
      });
    },
    patienten() {
      // zoek dubbele transacties op patienten
      let patient_list = [];
      for (let patient of this.parsedContents) {
        // build code counter object
        let code_counter = {};
        for (let decl of patient.declaraties) {
          let dag = decl.date;
          let code = decl.code;

          if (!code_counter[dag]) {
            code_counter[dag] = {};
          }
          if (!code_counter[dag][code]) {
            code_counter[dag][code] = 1;
          } else {
            code_counter[dag][code]++;
          }
        }

        for (const [dag, codes] of Object.entries(code_counter)) {
          let tot_aantal = 0;

          for (const [code, aantal] of Object.entries(codes)) {
            tot_aantal += aantal;

            if (
              this.codes_allow_dubbel.indexOf(code) !== -1 ||
              this.codes_need_others[code] ||
              this.codes_warn_others[code] ||
              this.codes_opt_others.indexOf(code) !== -1
            ) {
              tot_aantal -= 1;
            }

            if (this.codes_need_others[code]) {
              let ok = false;
              for (let needed_code of this.codes_need_others[code]) {
                if (codes[needed_code]) {
                  ok = true;
                }
              }
              if (!ok) {
                patient.dubbel_msg.push(
                  code +
                    " zonder " +
                    this.codes_need_others[code].join(", ") +
                    "."
                );
                patient.error_days.push(dag);
              }
            }
            if (this.codes_warn_others[code]) {
              let ok = false;
              for (let needed_code of this.codes_warn_others[code]) {
                if (codes[needed_code]) {
                  ok = true;
                }
              }
              if (!ok) {
                patient.warn_msg.push(
                  code +
                    " zonder " +
                    this.codes_warn_others[code].join(", ") +
                    "."
                );
                patient.error_days.push(dag);
              }
            }
          }

          if (codes["HECHT"]) {
            patient.warn_msg.push("HECHT, geen CHI?.");
            patient.error_days.push(dag);
          }

          if (tot_aantal > 1) {
            // meerdere declaraties op 1 dag
            patient.dubbel_msg.push("Te veel declaraties op " + dag + "?");
            patient.error_days.push(dag);
          }
        }

        patient_list.push(patient);
      }
      return patient_list;
    },
    parsedContents() {
      if (!this.file_contents) {
        return [];
      }
      let lines = this.file_contents.split(/\r?\n/);
      let patient = null;
      let patienten = [];
      for (let i = 0; i < lines.length; i++) {
        let line = lines[i];
        if (patient) {
          // check op declaratie regel
          let decl_line_matches = line.match(
            /^ {10,}(\d{2}-\d{2}-\d{2,4}) ([A-Z]+) +((.*))\s+(\d+(?:,\d{2}))$/i
          );

          if (decl_line_matches) {
            let decl = {
              date: decl_line_matches[1],
              code: decl_line_matches[2],
              descr: decl_line_matches[4].trim(),
              bedrag: parseFloat(decl_line_matches[5].replace(",", "."))
            };
            patient.declaraties.push(decl);
            if (!this.alle_codes[decl.code]) {
              // eslint-disable-next-line vue/no-side-effects-in-computed-properties
              this.alle_codes[decl.code] = {
                code: decl.code,
                aantal: 0,
                omzet: 0
              };
            }
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.alle_codes[decl.code]["aantal"]++;
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.alle_codes[decl.code]["omzet"] += decl.bedrag;
            continue;
          }
        }
        // check op nieuwe patient regel
        let patient_line_matches = line.match(
          /^ {5}(\d{2}-\d{2}-\d{2,4}) ([^,]*?) *(?:,(.*): (\d+))?(\s*)$/i
        );
        if (patient_line_matches) {
          // create new patient
          if (patient) {
            patienten.push(patient);
          }
          patient = {
            dob: patient_line_matches[1],
            name: patient_line_matches[2].trim(),
            id_type: patient_line_matches[3],
            id_nr: patient_line_matches[4],
            declaraties: [],
            dubbel_msg: [],
            warn_msg: [],
            error_days: []
          };
        }
      }
      if (patient) {
        patienten.push(patient);
      }

      return patienten;
    }
  },
  watch: {},
  methods: {
    readFile(File) {
      if (File[0]) {
        this.state = "READING";
        const reader = new FileReader();
        this.selected_file = File[0];

        reader.onload = e => {
          this.state = "PROCESSING";
          this.$nextTick(() => {
            this.file_contents = e.target.result;
            this.state = "DONE";
          });
        };
        reader.readAsText(File[0]);
      } else {
        this.file_contents = null;
        this.state = "IDLE";
      }
    }
  }
};
</script>
